import { DownloadOutlined } from "@ant-design/icons";
import { Button } from "antd";
import { useTranslation } from "react-i18next";

interface DownloadFileProps {
  fileContent: string | Blob;
  fileName: string;
  fileType: "application/json";
}

export function DownloadFile({
  fileContent,
  fileName,
  fileType,
}: DownloadFileProps) {
  const { t } = useTranslation();

  const handleDownload = () => {
    const blob =
      fileContent instanceof Blob
        ? fileContent
        : new Blob([fileContent], { type: fileType });
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <>
      <Button icon={<DownloadOutlined />} onClick={handleDownload}>
        {t("beacon:configure-download")}
      </Button>
    </>
  );
}
